import { Component, inject, OnInit } from '@angular/core';
import {
  CustomerService,
  GungFlowService,
  ProductGridCardV2Component
} from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'cult-cult-product-grid-card-v2',
  templateUrl: './cult-product-grid-card-v2.component.html',
  styleUrls: ['./cult-product-grid-card-v2.component.scss'],
  standalone: false
})
export class CultProductGridCardV2Component extends ProductGridCardV2Component implements OnInit {
  protected gungFlowService = inject(GungFlowService);
  protected customerService = inject(CustomerService);

  isReturNoPrice = false;
  isReturnFlow = false;
  customerPriceList: string = '';

  ngOnInit(): void {
    super.ngOnInit();
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
    this.gungFlowService
      .getSelectedFlow()
      .pipe()
      .subscribe(flow => {
        if (flow.isReturnOrder) {
          this.isReturnFlow = true;
        }
      });

    const customerIdFromLocalstorage = localStorage.getItem('selectedCustomerId');

    if (customerIdFromLocalstorage) {
      this.customerService
        .getCustomer(customerIdFromLocalstorage)
        .pipe()
        .subscribe(customer => (this.customerPriceList = customer.extra.kus.prislista || ''));
    }
  }
}
